<template>
  <el-dialog width="60%"
             title="详情"
             :visible.sync="viewDetail"
             @close="closeModel">
    <div class="main">

      <div class="oder-info">
        <h4>账单信息</h4>
        <p>订单号：{{item.order_sn}}</p>
        <p>套餐名称：{{item.subject_name}}</p>
        <p  >套餐时效：
          {{item.time_option=='1_year'?'包年':item.time_option=='三个月'?'三个月':'包月'}}
          </p>
        <p>当前状态：{{item.status}}</p>
        <p>支付金额：{{item.amount}}</p>
        <el-table :data="tableData"
                  border
                  fit
                  height="300px"
                  :header-cell-style="{background:'#F8F9FE',color:'#666666'}">
          <el-table-column prop="type"
                           label="配置类型">
          </el-table-column>
          <el-table-column prop="name"
                           label="配置模块">
          </el-table-column>
          <el-table-column prop="amount"
                           label="单价（元）">
          </el-table-column>
        </el-table>
      </div>

    </div>

  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    did: {
      require: true
    }

  },
  data () {
    return {
      viewDetail: true,
      tableData: [],
      item: {}

    };
  },
  mounted () {
    this.getgetPaymentD()
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  methods: {
    ...mapActions({
      getPaymentD: "detect/getPaymentD", //产品列表
    }),
    closeModel () {
      this.$emit('closeModel')
    },
    getgetPaymentD () {
      let params = {
        token: this.getToken,
        id: this.did
      }
      console.log(this.did, 'this.did')
      this.getPaymentD(params).then(({ data }) => {
        if (data.code == 1) {
          this.item = data.data
          if (data.data.service || data.data.service) {
            let arr = []
            let arr1 = []
            data.data.service.forEach(el => {
              el.type = '服务配置'
            })
            data.data.platform.forEach(el => {
              el.type = '平台配置'
            })
            this.tableData = [...data.data.service, ...data.data.platform]
          }


          /*  this.comboList = data.data; */
          // this.comboList = [...data.data, ...data.data, ...data.data];
        } else {
          this.$message.error(data.msg);
        }
      });


    }

  },
  components: {

  },
};
</script>

<style scoped lang="scss">
.main {
  padding: 0 20px;
  .oder-info {
    width: 100%;
    p {
      font-size: 14px;
      padding: 10px 20px 10px 40px;
      color: #666666;
    }
  }

  h4 {
    padding-left: 20px;
    line-height: 18px;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 2px;
      background: #2448ff;
    }
  }
}
</style>
